module.exports = __webpack_public_path__ + "ced4dc12a78ec487d4bbc3fbfc4b32e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-pirate-s.png
// module id = 1963
// module chunks = 0